<th *ngIf="column.sortable; else notSortable">
  {{ column.header || translations[column.headerKey] }}
  <p-sortIcon [field]="!!column.sortField ? column.sortField : column.field"></p-sortIcon>
</th>
<ng-template #notSortable>
  <th>{{ column.header || translations[column.headerKey] }}</th>
</ng-template>
